import Model from '@/lib/data/Model';
import VisitFormScore from './VisitFormScore';

const fixedDecimals = function (v) {
    return Number.isNaN(v) ? 0 : parseFloat(parseFloat(v).toFixed(2));
};

class VisitRisk extends Model {
    fields = [
        { name: 'ratio', getter: fixedDecimals },
        {
            name: 'scores',
            association: {
                type: 'many',
                model: VisitFormScore,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/risk/result',
            params: ['visit_id', 'language_code'],
        },
    ];
}

export default VisitRisk;
